import { CustomAction } from 'model/state';
import { START_PRESENCE_NOTIFICATIONS , STOP_PRESENCE_NOTIFICATIONS } from 'constants/ActionTypes';

/**
 * Payload
 */
export interface PresencePayload {
  locationIds?: string[];
  deviceIds?: string[];
}

/**
 * Actions
 */
export const startPresence = (locationIds?: string[], deviceIds?: string[]): CustomAction<PresencePayload> => {
  return {
    type: START_PRESENCE_NOTIFICATIONS,
    payload: { locationIds, deviceIds }
  };
};

export const stopPresence = (): CustomAction<PresencePayload> => {
  return {
    type: STOP_PRESENCE_NOTIFICATIONS,
  };
};
